import { render, staticRenderFns } from "./ReferralsModal.vue?vue&type=template&id=b809ea38&scoped=true&"
import script from "./ReferralsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./ReferralsModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ReferralsModal.vue?vue&type=style&index=0&id=b809ea38&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b809ea38",
  null
  
)

export default component.exports